import { Box, Typography, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import CompleteCargoCard from "./CompleteCargoCard";
import useSWRMutation from "swr/mutation";
import { fetcherPost } from "../../../../../services/fetcher";
import { useAppDispatch } from "../../../../../hooks/useRedux";
import {
  setOpenSnackbar,
  setSnackbarDescription,
  setSnackbarErrorStatus,
} from "../../../../../redux/features/snackbarSlice";
import { DotLoader } from "react-spinner-overlay";
import EmptyCargoSVG from "../../../../../media/images/icons/empty-cargo";
import { blueGrey } from "@mui/material/colors";

export interface INobatHistory {
  id: "66937b5060219b21bc30dece";
  salonName: "بازارگاه سراسری";
  terminalName: "بازارگاه مجازی سمند ترابر";
  cityName: "تهران";
  nobatDate: "2024-07-14T07:16:32.851Z";
  queueNr: number;
  nobatStatus: number;
  bolNumber: 14032004789;
  bolFare: null;
  dolNumber: null;
  bolDate: null;
  companyName: "تجارت";
  plauqeNr: "758ع61 ایران 93";
  loaderTypeName: "کفی  12چرخ";
  licenseNr: 16;
  bolSerialNumber: "100";
  dolDate: "0001-01-01T00:00:00";
  licenseIssueDate: "2024-07-14T07:28:13.057Z";
  companyTel: "02148279808";
  companyAddress: "پیکانشهر";
  loaderTypeGroup: "تریلر کفی ";
  destination: "یزد";
  goodsName: "انواع قطعات ماشین آلات سنگین";
  ladingDate: "2024-07-10T06:30:42Z";
  isFarePaid: null;
  ladingDateTo: "2024-07-10T12:30:42Z";
}

export default function CompleteCargos() {
  const dispatch = useAppDispatch();

  const theme = useTheme();

  const [nobatHistories, setNobatHistories] = useState<INobatHistory[]>([]);

  const {
    trigger: getDriverNobatHistory,
    isMutating: isgetDriverNobatHistoryMutting,
  } = useSWRMutation(
    [`/Nobat/GetDriverNobatHistory`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: (data) => {
        setNobatHistories(data);
      },
    }
  );

  useEffect(() => {
    getDriverNobatHistory({
      getActiveNobat: false,
      nobatStatus: 5,
      pageNr: 1,
    });
  }, []);

  return (
    <Box
      sx={{
        mt: 2,
        display: "flex",
        flexDirection: "column",
        gap: "8px",
      }}
    >
      {isgetDriverNobatHistoryMutting ? (
        <Box
          sx={{
            height: "200px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "16px",
          }}
        >
          <DotLoader color={theme.palette.primary.main} />
          <Typography>لطفا منتظر باشید...</Typography>
        </Box>
      ) : !nobatHistories.length ? (
        <Box
          sx={{
            height: "200px",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "16px",
          }}
        >
          <EmptyCargoSVG size={125} color={theme.palette.primary.main} />
          <Typography
            maxWidth={150}
            textAlign={"center"}
            sx={{
              fontWeight: "700",
              color: blueGrey[500],
            }}
          >
            در حال حاضر محموله تکمیل شده ندارید
          </Typography>
        </Box>
      ) : (
        nobatHistories.map((item) => (
          <CompleteCargoCard key={item.id} {...item} />
        ))
      )}
    </Box>
  );
}
